// extracted by mini-css-extract-plugin
export default {"parentdiv":"AboutCardIcon_parentdiv__QIs8H"};